// Lodash
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

// VUE
import Vue from "vue";
import VueRouter from "vue-router";
import testimonialsList from './components/TestimonialsList.vue';
import banksList from './components/BanksList.vue';
import blogPage from './components/BlogPage.vue';
import creditCalc from './components/CreditCalc.vue';
import apartmentOrderForm from './components/ApartmentOrderForm.vue';
import catalogPage from './components/CatalogPage.vue';
import apartmentCreditCalc from './components/ApartmentCreditCalc.vue';
import apartmentsPage from './components/ApartmentsPage.vue';

// Other
import initForms from './components/FormHelper';
import './app'; // Markuper scripts

initForms('form[action]');

// Temp hack for credicCalc modal. Will be removed in future
$(document).ready(() => {
    let $modal = $("#creditPopup");
    let $form = $('.credit-page .about-layout__credit_form > form').eq(0);
    $("#creditBtn").click(function () {
        let value = $form.find(".result > span").text();
        $modal.find("input[name='credit']").val(value);    
    });
});


// Another ugly hack 
$(document).ready(() => {
    let $modal = $("#creditPopup");
    let $button = $modal.find("button[type='submit']")
    $button.click(function () {
        let value = $(".calculate-credit-block__container .sum > p > span ").eq(0).text();
        $modal.find("input[name='credit']").val(value);
    });
});

// For input[type="range"]
$(document).ready(() => {
    let $rangeInput = $('.range__input');
    let $currentValBlock = $('.range__current_value');
    let $progressBar = $('.range__input_progress_bar');
    let $coords = () => ($rangeInput.val() - $rangeInput.attr('min')) / ($rangeInput.attr('max') - $rangeInput.attr('min')) * 100;
    
    
    $progressBar.css('width', $coords() + '%');
    $currentValBlock.text($rangeInput.val());
    $currentValBlock.css('left', $coords() + '%');
    $currentValBlock.css('transform', 'translateX(' + -$coords() + '%)');

    $rangeInput.on('input', function() {
        $coords() < 80 ? $progressBar.css('width', $coords() + '%') : $progressBar.css('width', ($coords() - 1) + '%');
        $currentValBlock.text(this.value);
        $currentValBlock.css('left', $coords() + '%');
        $currentValBlock.css('transform', 'translateX(' + -$coords() + '%)');
    })
});



function searchApartmentsFormInit() {
    let all_Steps_Appartments_Search_Form = document.querySelectorAll('.form-step__wrapper'),
        counterSteps = document.querySelector('.apartments-search-form__subtitle_counter'),
        subTitleForm = document.querySelector('.apartments-search-form__subtitle'),
        subTitleFormText = subTitleForm.textContent;

    let requiredFields = [
        document.getElementById('send_to_phone'),
        document.getElementById('send_to_whatsapp'),
        document.getElementById('send_to_email')
    ];
        
    requiredFields.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            let wrap = this.closest('.form-step__checkboxes_wrapper');
            let nextBtn = this.closest('.form-step__wrapper').querySelector('button.btn__next');
            let isChecked = requiredFields.some(f => f.checked);

            whatIsCheckedToRequired(requiredFields);

            if(isChecked) {                  
                if(wrap.classList.contains('has-error')) {
                    wrap.classList.remove('has-error');
                    nextBtn.disabled = false;
                }
            } else {
                wrap.classList.add('has-error');
                nextBtn.disabled = true;           
            }
        });
    });

    let clearActivesSteps = () => all_Steps_Appartments_Search_Form.forEach(s => s.classList.remove('_active__step'));

    function whatIsCheckedToRequired(checkedWayOfConnection) {
        let phoneInput = document.getElementById('phone_number'),
            emailInput = document.getElementById('email_address'),
            lastStepBtn = document.getElementById('last_step');

        function checkEmailInput() {
            if(checkedWayOfConnection[2].checked) {
                
                if((/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(this.value)) {
                    lastStepBtn.disabled = false;
                } else {
                    lastStepBtn.disabled = true;
                }
            } else lastStepBtn.disabled = false;
        }

        emailInput.removeAttribute('data-validation');
        emailInput.classList.remove('error');
        emailInput.style = '';
        phoneInput.removeAttribute('data-validation');
        phoneInput.classList.remove('error');
        phoneInput.style = '';
        lastStepBtn.disabled = false;
        
        if(checkedWayOfConnection[2].checked) {
            emailInput.setAttribute('data-validation', 'email required');
            // lastStepBtn.disabled = true;
            checkEmailInput.call(emailInput);
            emailInput.addEventListener('input', checkEmailInput);
        } 
            
        if(checkedWayOfConnection[0].checked || checkedWayOfConnection[1].checked) 
            phoneInput.setAttribute('data-validation', 'required');
    }
    
    all_Steps_Appartments_Search_Form.forEach((step, i) => {
        let backBtn = step.querySelector('button.btn__back'),
            nextBtn = step.querySelector('button.btn__next');
    
        backBtn.addEventListener('click', function() {
            if(i > 0) { 
                clearActivesSteps();
                this.closest(`#step_${i + 1}`).previousElementSibling.classList.add('_active__step');
                counterSteps.textContent = `${i}/6`;
                document.querySelector('.apartments-search-form__subtitle_wrapper').classList.remove(`__s_${i}`);
            }
        });

        nextBtn.addEventListener('click', function() {
            if(i < 5) {
                if(i === 3) {
                    let isChecked = requiredFields.some(f => f.checked);
                    if(!isChecked) {
                        this.disabled = true;
                        document.querySelector('.form-step__checkboxes_wrapper').classList.add('has-error');
                        return;
                    } else {
                        whatIsCheckedToRequired(requiredFields);
                    }
                }  

                clearActivesSteps();
                this.closest(`#step_${i + 1}`).nextElementSibling.classList.add('_active__step');
                counterSteps.textContent = `${i+2}/6`;
                document.querySelector('.apartments-search-form__subtitle_wrapper').classList.add(`__s_${i+1}`);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => { 
    searchApartmentsFormInit(); 
});

// Register all the basic Vue components
const requireComponent = require.context('./components/basic/', true, /[A-Z]\w+\.(vue|js)$/); 
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')));
    Vue.component(componentName, componentConfig.default || componentConfig);
  });


Vue.use(VueRouter);

new Vue({
    el: "#app",
    components: {
        testimonialsList,
        banksList,
        blogPage,
        creditCalc,
        apartmentOrderForm,
        catalogPage,
        apartmentCreditCalc,
        apartmentsPage
    }
});